export const iconFontAwesomeWritingPenToSquare = (
	<i className="fa-solid fa-pen-to-square"></i>
);
